export default __webpack_public_path__ + "static/media/video_player_bg.f3c49b37.png";